export default "__VITE_ASSET__oNVJaeOT__$_?height=200&width=300__"